import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgIf, AsyncPipe } from '@angular/common';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-release-notes',
  templateUrl: './release-notes.component.html',
  styleUrls: ['./release-notes.component.scss'],
  standalone: true,
  imports: [NgIf, AsyncPipe],
})
export class ReleaseNotesComponent {
  @Input() show = false;
  @Output() dismiss = new EventEmitter<void>();
  
  constructor(public auth: AuthService) {}

  // --- PINNED FUNCTIONALITY REMOVED ---
  // For development: modal will show on every refresh.
  // IMPORTANT: Remove this and restore once-per-user logic before production!
  // See app.component.ts for the original logic to only show once per user/version.

  onBackdrop(event: MouseEvent) {
    this.dismiss.emit();
  }
  onModalClick(event: MouseEvent) {
    event.stopPropagation();
  }
  onDismissClick() {
    // Add a visual indicator that the button was clicked
    const closeBtn = document.querySelector('.modal-announcement .btn-close') as HTMLElement;
    if (closeBtn) {
      // Add a pressed state visual feedback
      closeBtn.classList.add('clicked');
      // Disable the button to prevent multiple clicks
      closeBtn.setAttribute('disabled', 'true');
    }
    
    // Emit the dismiss event immediately
    this.dismiss.emit();
    
    // Force hide the modal after a short timeout if it's still visible
    // This is a fallback in case the parent component doesn't respond quickly
    setTimeout(() => {
      this.show = false;
    }, 100);
  }
}
